import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1a76j4s-0"
})(["padding:18px 24px 0;"]);